import { NgModule } from '@angular/core'
import { ZardCheckboxComponent } from '@/styles/components/checkbox'
import {
    ZardDropdownMenuComponent,
    ZardDropdownMenuItemComponent,
} from '@/styles/components/dropdown'
import { ZardTabGroupComponent, ZardTabComponent } from '@/styles/components/tabs'
import { ZardDividerComponent } from '@/styles/components/divider'
import { ZardTooltipDirective } from '@/styles/components/tooltip'
import { ZardLoaderComponent } from '@/styles/components/loader'
import { ZardSwitchComponent } from '@/styles/components/switch'
import { ZardRadioComponent } from '@/styles/components/radio'
import {
    ZardFormFieldComponent,
    ZardFormControlComponent,
    ZardFormLabelComponent,
    ZardFormMessageComponent,
} from '@/styles/components/form'
import { ZardSelectComponent, ZardSelectItemComponent } from '@/styles/components/select'
import { ZardInputDirective } from '@/styles/components/input'
import { ZardCardComponent } from '@/styles/components/card'
import { ZardToastComponent } from '@/styles/components/toast'
import { SvgIconComponent } from '@app/shared/components/svg-icon/svg-icon.component'
import {
    TwAutocompleteComponent,
    TwAutocompleteOptionComponent,
} from '@app/shared/components/tw-autocomplete/tw-autocomplete.component'

const zardModules = [
    ZardDividerComponent,
    ZardTooltipDirective,
    ZardLoaderComponent,
    ZardSwitchComponent,
    ZardRadioComponent,
    ZardCheckboxComponent,
    ZardFormFieldComponent,
    ZardFormControlComponent,
    ZardFormLabelComponent,
    ZardFormMessageComponent,
    ZardSelectComponent,
    ZardSelectItemComponent,
    ZardInputDirective,
    ZardTabGroupComponent,
    ZardTabComponent,
    ZardCardComponent,
    ZardDropdownMenuComponent,
    ZardDropdownMenuItemComponent,
    ZardToastComponent,
    SvgIconComponent,
    TwAutocompleteComponent,
    TwAutocompleteOptionComponent,
]

@NgModule({
    imports: [...zardModules],
    exports: [...zardModules],
})
export class MaterialModule {}
